<template>
  <div class="flex flex-col gap-5 md:gap-7.5 xl:gap-10">
    <SectionTitle v-if="title" :title="title" class="no-underline!" />

    <div class="flex flex-col">
      <div class="flex flex-col gap-10 md:gap-15 xl:gap-17.5 2xl:gap-20">
        <EventCard
          v-for="event in initialEvents"
          :key="event.id"
          :slide="event"
        />
      </div>

      <div
        v-if="animatedEvents?.length > 0"
        class="grid transition-all duration-500 ease-in-out"
        :class="
          isExpanded
            ? 'mt-10 grid-rows-[1fr] opacity-100 md:mt-15'
            : 'mt-0 grid-rows-[0fr] opacity-0'
        "
      >
        <div class="flex flex-col gap-10 overflow-hidden md:gap-15">
          <EventCard
            v-for="event in animatedEvents"
            :key="event.id"
            :slide="event"
          />
        </div>
      </div>
    </div>

    <ShowMoreButton
      v-if="events?.length > 2"
      v-model:is-expanded="isExpanded"
      type="border"
      class="mt-2.5"
      button-color="dark"
    />
  </div>
</template>

<script setup lang="ts">
import type { Slide } from '~/types'

interface Props {
  title?: string
  events: Slide[]
}

const props = defineProps<Props>()

const isExpanded = ref(false)

const initialEvents = computed(() => {
  return props.events?.slice(0, 2)
})

const animatedEvents = computed(() => {
  return props.events?.slice(2)
})
</script>
